/**
 * A place for browser based navigation within an Appn context
 */
namespace appn.location {

    export function reloadCurrentPage(withMessage?: string) {
        // Always show the loading dialog
        appn.dialog.hide();
        appn.dialog.showLoading(withMessage);
        (window as any).location = window.location.href.endsWithIgnoreCase('#') ? window.location.href.slice(0, -1) : window.location.href;
    }

    /**
     * Takes in name value pair and makes a pretty query string
     * Automatically handles encoding and chars ? & =
     * returns eg: ?param1=p1&param2=p2
     */
    export function buildQueryString(queryStringParams: INameValuePair[]): string {
        // Build up the query string based on the params
        let queryString = appn.emptyString;
        if (queryStringParams && queryStringParams.length > 0)
            for (let i = 0; i < queryStringParams.length; i++)
                queryString += (i === 0 ? '' : '&') + encodeURIComponent(queryStringParams[i].name.toString().trim()) + '=' + encodeURIComponent(queryStringParams[i].value.toString().trim());

        // Prepend the ?
        if (queryString.length > 0)
            queryString = '?' + queryString;

        return queryString;
    }

    export function buildUrl(url: string, queryStringParams: INameValuePair[]): string {
        if (!queryStringParams)
            return url;

        return url + buildQueryString(queryStringParams);
    }

    export function buildUrlWithQueryString(url: string, queryStringParams?: INameValuePair[]): string {
        if (!url)
            return appn.emptyString;

        const queryString = buildQueryString(queryStringParams as INameValuePair[]);

        return url + queryString;
    }

    /**
     * Will load the url and automatically encode the query string params.
     * If called from child iframe, will pass call onto parent for execution.
     */
    export function navTo(url: string, queryStringParams?: INameValuePair[], withLoadingMessage?: string, isNewWindow?: boolean, loadInChild?: boolean) {
        if (parent !== window && !loadInChild)
            return (parent as any).appn.location.navTo(url, queryStringParams, withLoadingMessage, isNewWindow);

        if (!url)
            return;

        if (!isNewWindow) {
            appn.dialog.showLoading(withLoadingMessage);
            (window as any).location = buildUrl(url, queryStringParams as INameValuePair[]);
        } else 
            window.open(buildUrl(url, queryStringParams as INameValuePair[]), '_blank'); 
    }
    
    /**
     * Finds the text in the url
     */
    export function urlContains(text: string) {
        return window.location.href.containsIgnoreCase(text);
    }
}
